import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installDebugHelper } from './lib/buildInfo';
import './styles/tokens.css';
import './styles/global.css';

installDebugHelper();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
